/**
 * リンクで確認の画面（pages/ConfirmAction.tsx）が本体を呼ぶ唯一の場所（2026-09-28 creator/confirm-link）。
 *
 * 型の正: docs/teams/creator/tasks/confirm-link.md「④ ダッシュボード」（Core core/pending-actions のリーダー確定版）。Core の README が
 * 入ったらそちらが正（食い違いはここだけ直す）。認証は kds_（ログイン中のセッション・api() が付ける）。kdt_ では呼べない口。
 *   approve: 本文なし（束のときだけ { bundleCount }・2026-09-29）・メール確認済みが要る（403 email_unverified）・承認の時にも前提を見る（409 pending_action_stale）・
 *            pending でなければ 409 pending_action_closed { details.status }
 *   deny:    メール未確認でも可（心当たりの無い操作は誰でも消せる = 取り消しは止めない）
 * 実行はしない（本体も）: 承認は「エージェントの送り直しを 1 回だけ通す印」
 */
import { api } from './api';

const base = (id: string) => `/v1/developers/pending-actions/${encodeURIComponent(id)}`;

/** 画面は useResource で読む（読み込み中・エラーの扱いを他の画面とそろえる）。応答は PendingActionResponse */
export const pendingActionPath = (id: string) => base(id);

/**
 * body（2026-09-29 creator/confirm-bundle）: 束のときは { bundleCount: <画面に出した件数> } が要る（pendingAction.ts の approveBody）。
 * 違えば 409 pending_bundle_changed（開いた後に足された）。1 件なら本文なし（今までどおり）
 */
export function approvePendingAction(id: string, body?: { bundleCount: number }) {
  return api<unknown>(`${base(id)}/approve`, { method: 'POST', ...(body ? { body } : {}) });
}

export function denyPendingAction(id: string) {
  return api<unknown>(`${base(id)}/deny`, { method: 'POST' });
}
